import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';

class FooterContainer extends Component {

  constructor(props) {
    super(props);

    let state = {};

    if(this.props.footer && this.props.footer.acf){
      state = this.props.footer.acf;
    }

    this.state = { ...state };
  }

  render() {
    return (
      <footer className="page-footer">
        <Container>
          <Row>
            <Col>
              <img className="footer-logo" src={require('../../assets/images/logo.png')} alt="Obelux"/>
              <div className="footer-navi">{ this.props.children }</div>
            </Col>
          </Row>
          <Row className="footer-info">

            <Col xs="12" md={{ size: 5 }} lg={{ size: 6 }} className={"footer-rights"}>
              <p className="copy">© 2018 OBELUX. All Rights Reserved</p>
            </Col>
            { /*
            <Col xs="12" md={{ size: 6 }} lg={{ size: 4 }}>
              <ul className="legals"><li><a href="">Legal Notes</a></li><li><a href="">Privacy Policy</a></li></ul>
            </Col>
            */ }
            <Col xs="12" md="7" lg="6" className={"footer-main"}>
              <Row>
                <Col xs="5" className="visiting-address">
                  <h2>Visiting Address</h2>
                  <ul>
                    <li>{ this.state.obx_address }</li>
                    <li>{ this.state.obx_postal_code + " " + this.state.obx_city }</li>
                    <li>{ this.state.obx_country }</li>
                    <li className="space-above"><a href={ "mailto:" + this.state.obx_email_info }>{ this.state.obx_email_info }</a></li>
                    <li><a href={ "mailto:" + this.state.obx_email_helpdesk }>{ this.state.obx_email_helpdesk }</a></li>
                  </ul>
                </Col>
                <Col xs="7" className="company-info">
                  <table>
                    <tbody>
                      <tr>
                        <td className="header-cell">Tel</td><td>{ this.state.obx_tel}</td>
                      </tr>
                      <tr>
                        <td className="header-cell">Fax</td><td>{ this.state.obx_fax }</td>
                      </tr>
                      <tr>
                        <td className="header-cell">VAT ID</td>
                        <td>{ this.state.obx_vat_id }</td>
                      </tr>
                      <tr>
                        <td className="header-cell">Comp. no</td>
                        <td>{ this.state.obx_comp_number }</td>
                      </tr>
                      <tr>
                        <td className="header-cell">Trade Reg</td><td>{ this.state.obx_trade_reg}</td>
                      </tr>
                      <tr>
                        <td className="header-cell">Domicile</td><td>{ this.state.obx_domicile }</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}

export const Footer = connect(
  state => ({
    footer: state.resolve.data.footer
  })
)(FooterContainer);



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js